export default __webpack_public_path__ + "static/media/apruvd-logo.6cfc60f6.png";